//@ts-nocheck
import React from "react";
import { createRoot } from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { StateInspector } from "reinspect";
import { CookiesProvider } from "react-cookie";
import { PostHogProvider } from "posthog-js/react";

const postHogOptions = {
  api_host: process.env.REACT_APP_POSTHOG_HOST,
  loaded: (posthogInstance: PostHog) => {
    console.log(
      `PostHog initialized in ${process.env.REACT_APP_ENVIRONMENT} mode`
    );
    posthogInstance.register({
      environment: process.env.REACT_APP_ENVIRONMENT || "unknown",
    });
  },
  // Recommended for public pages
  autocapture: false,
  capture_pageview: false,
};

// createRoot(
//   <React.StrictMode>
//     <StateInspector name="PORTAL_APP_STORE">
//       <CookiesProvider>
//         <App />
//       </CookiesProvider>
//     </StateInspector>
//   </React.StrictMode>,
//   document.getElementById("root")
// );

const container = document.getElementById("root");
const root = createRoot(container);
root.render(
  <React.StrictMode>
    <PostHogProvider
      apiKey={process.env.REACT_APP_POSTHOG_KEY}
      options={postHogOptions}
    >
      <StateInspector name="PORTAL_APP_STORE">
        <CookiesProvider>
          <App />
        </CookiesProvider>
      </StateInspector>
    </PostHogProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
